import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppLayoutComponent } from './@layout/app-layout.component';
import { BodyComponent } from './@layout/body/body.component';

export const AppRoutes: Routes = [
  {
    path: 'app',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: BodyComponent,
        children: [
          {
            path: 'index',
            loadChildren: './dashboard/app-dashboard.module#AppDashboardModule'
          },
          {
            path: 'sample-page',
            loadChildren: './company/company.module#CompanyModule'
          },
          {
            path: 'chit',
            loadChildren: './chit/chit.module#ChitModule'
          },
          {
            path: 'user',
            loadChildren: './user/user.module#UserModule'
          },
          {
            path: 'offer',
            loadChildren: './offer/offer.module#OfferModule'
          },
          {
            path: 'payout',
            loadChildren: './payout/payout.module#PayoutModule'
          },
          {
            path: 'cheque',
            loadChildren: './cheque/cheque.module#ChequeModule'
          },
          {
            path: 'mobile',
            loadChildren: './mobile/mobile.module#MobileModule'
          },
          {
            path: 'purchase',
            loadChildren: './purchase/purchase.module#PurchaseModule'
          },
          {
            path: 'payment',
            loadChildren: './payment/payment.module#PaymentModule'
          },
          {
            path: 'super-admin',
            children: [
              {
                path: 'permission',
                loadChildren: './superadmin/permission/permission.module#PermissionModule'
              },
              {
                path: 'mobile',
                loadChildren: './superadmin/mobile/mobile.module#MobileModule'
              },
              {
                path: 'company',
                loadChildren:
                  './superadmin/company/company.module#CompanyModule'
              }
            ]
          },
          {
            path: '',
            redirectTo: '/app/index',
            pathMatch: 'full'
          }
        ]
      }
    ]
  },
  {
    path: '',
    redirectTo: '/app/index',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/app/index',
    pathMatch: 'full'
  }];

@NgModule({
  imports: [RouterModule.forChild(AppRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/app.routing.ts